import Request from "@/services/request";
import {
  DELETE_SUB_ACCOUNTS,
  RESET_PASSWORD_SUB_ACCOUNTS,
  CHANGE_PASSWORD_SUB_ACCOUNTS,
  SELLER_SUB_ACCOUNTS,
  SELLER_DASHBOARD_QUERY_CONFIGS,
} from "@/utils/enum/endpoints";
import { SUB_ACCOUNT_LIMIT } from "@/utils/enum/configs";
import {
  CREATE_SUB_ACCOUNT_PENDING,
  CREATE_SUB_ACCOUNT_SUCCESS,
  CREATE_SUB_ACCOUNT_FAIL,
  DELETE_SUB_ACCOUNT_PENDING,
  DELETE_SUB_ACCOUNT_SUCCESS,
  DELETE_SUB_ACCOUNT_FAIL,
  RESET_PASSWORD_SUB_ACCOUNT_PENDING,
  RESET_PASSWORD_SUB_ACCOUNT_SUCCESS,
  RESET_PASSWORD_SUB_ACCOUNT_FAIL,
  CHANGE_PASSWORD_SUB_ACCOUNT_PENDING,
  CHANGE_PASSWORD_SUB_ACCOUNT_SUCCESS,
  CHANGE_PASSWORD_SUB_ACCOUNT_FAIL,
  SET_SUB_ACCOUNT_LIMIT,
} from "./mutation-types";

const request = new Request();

const createSubAccount = async ({ commit }, payload) => {
  commit(CREATE_SUB_ACCOUNT_PENDING);
  try {
    const { data } = await request.post(`${SELLER_SUB_ACCOUNTS}`, {
      ...payload,
    });
    commit(CREATE_SUB_ACCOUNT_SUCCESS, data);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(CREATE_SUB_ACCOUNT_FAIL, data);
    return Promise.reject(data);
  }
};

const deleteSubAccount = async ({ commit }, payload) => {
  commit(DELETE_SUB_ACCOUNT_PENDING);
  try {
    const url = DELETE_SUB_ACCOUNTS.replace("{username}", payload);
    const { data } = await request.delete(url);
    commit(DELETE_SUB_ACCOUNT_SUCCESS, payload);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(DELETE_SUB_ACCOUNT_FAIL, data);
    return Promise.reject(data);
  }
};

const resetPasswordSubAccount = async ({ commit }, payload) => {
  commit(RESET_PASSWORD_SUB_ACCOUNT_PENDING);
  try {
    const url = RESET_PASSWORD_SUB_ACCOUNTS.replace("{username}", payload);
    const { data } = await request.post(url);
    commit(RESET_PASSWORD_SUB_ACCOUNT_SUCCESS);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(RESET_PASSWORD_SUB_ACCOUNT_FAIL, data);
    return Promise.reject(data);
  }
};

const changePasswordSubAccount = async ({ commit }, payload) => {
  commit(CHANGE_PASSWORD_SUB_ACCOUNT_PENDING);
  try {
    const { data } = await request.post(`${CHANGE_PASSWORD_SUB_ACCOUNTS}`, {
      ...payload,
    });
    commit(CHANGE_PASSWORD_SUB_ACCOUNT_SUCCESS);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(CHANGE_PASSWORD_SUB_ACCOUNT_FAIL, data);
    return Promise.reject(data);
  }
};

const getSubAccountLimit = async ({ commit }) => {
  try {
    const { data } = await request.get(SELLER_DASHBOARD_QUERY_CONFIGS, {
      configKeys: [SUB_ACCOUNT_LIMIT],
    });
    const limit = data[SUB_ACCOUNT_LIMIT] || data.configValues?.[SUB_ACCOUNT_LIMIT];
    commit(SET_SUB_ACCOUNT_LIMIT, limit);
    return Promise.resolve(limit);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  createSubAccount,
  deleteSubAccount,
  resetPasswordSubAccount,
  changePasswordSubAccount,
  getSubAccountLimit,
};
